import type { Cookie } from 'src/cookies';
import { getCookieWithKey } from 'src/cookies';
import { analyticsConsentCookieCategoryKey } from './cookie-types/analytical-cookies';

const IS_MEMBER_COOKIE_NAME = 'IsMember'; // set by DavidLloydWebsite

export const IS_MEMBER_COOKIE: Cookie = getCookieWithKey(
  IS_MEMBER_COOKIE_NAME,
  analyticsConsentCookieCategoryKey
);
